import { render, staticRenderFns } from "./tomadorAceitarTermo.vue?vue&type=template&id=431b5c93&scoped=true"
import script from "./tomadorAceitarTermo.vue?vue&type=script&lang=js"
export * from "./tomadorAceitarTermo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b5c93",
  null
  
)

export default component.exports